export class PaymentDoubleSubscriptionError extends Error {
  constructor() {
    super('Subscription is already active');
  }
}
